<template>
  <div>
    <el-input-number
      size="small"
      :precision="2"
      placeholder="请输入数字"
      v-model="value"
      :controls="false"
      @blur="updateValue"
      :min="info.detectionRangeMin"
      :max="info.detectionRangeMax"
    ></el-input-number>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: null
    };
  },
  props: ["info", "index"],
  watch: {
    info: {
      handler(newValue) {
        if(newValue.fieIdValue != undefined && newValue.fieIdValue != null) {
          this.value = newValue.fieIdValue
        } else if(newValue.defaultValue) {
          this.value = newValue.defaultValue
        } else {
          this.value = null
        }
        this.updateValue()
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    updateValue(e) {
      let obj = {
        type: 7,
        fieIdValue: this.value,
        fieIdId: this.info.fieIdId,
        index: this.index,
      };
      if (
        Number(this.value) < Number(this.info.detectionRangeMin) ||
        Number(this.value) > Number(this.info.detectionRangeMax)
      ) {
        this.value = this.info.detectionRangeMin;
        obj.fieIdValue = this.info.detectionRangeMin;
        this.$forceUpdate();
      }
      this.$emit("updateValue", obj);
    },
  },
};
</script>